import axios from 'axios'
import { Message } from 'view-ui-plus'

// create an axios instance

const service = axios.create({
  baseURL: process.env.VUE_APP_TEST_API, // api 的 base_url
  withCredentials: true, // 跨域请求时发送 cookies
  timeout: 1800000, // request timeout,
  headers: {'Content-Type': 'application/x-www-form-urlencoded'}
})
// request interceptor
service.interceptors.request.use(


  config => {
   
    return config
  },
  error => {
    // Do something with request error'
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(

  /**
   * If you want to get information such as headers or status
   * Please return  response => response
  */
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 XMLHttpRequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const headers = response.headers
    if (headers['content-type'] === 'application/octet-stream;charset=utf-8') {
      return response
    }
    if (response.data.code === "-1000" || response.data.resultCode==1000) {
      // store.dispatch('user/resetToken').then(() => {
      //   location.reload() // 为了重新实例化vue-router对象 避免bug
      // })
      return Promise.reject('error')
    } else if (response.data.code === 1001) {
      // store.dispatch('user/resetToken').then(() => {
      //   location.reload() // 为了重新实例化vue-router对象 避免bug
      // })
      // return Promise.reject('error')
      Message.error({
        content: response.data.msg || "服务器异常，请联系管理员!",
        duration: 2,
        onClose:function(){
          localStorage.clear()
          this.$router.push({ path: "/" })
        }
      });
    }else {
      return response
    }
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject(error)
  }
)

export default service
